import React, { useState } from 'react';
import './Projects.css';
import { projectsData } from '../data/portfolioData';
import { FaExternalLinkAlt, FaTimes } from 'react-icons/fa';
import museumImage from '../images/Museum_of_Science_and_Industry_(Chicago).jpg';
import nfhaImage from '../images/nfha.jpg';
import sameSameImage from '../images/samesame.webp';
import subwaySurferImage from '../images/subwaysurfer.jpg';

const Projects: React.FC = () => {
  const projects = projectsData.map((p) => 
    p.title.includes('Open Communities')
      ? { ...p, image: { url: nfhaImage } }
      : p.title.includes('DataBites')
      ? { ...p, image: { url: museumImage } }
      : p.title.includes('SameSame')
        ? { ...p, image: { url: sameSameImage } }
        : p.title.includes('Subway Surfers')
          ? { ...p, image: { url: subwaySurferImage } }
          : p
  );
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const handleCardClick = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="projects-container">
      <h2 className="projects-title">Projects</h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div
            key={index}
            className={`project-card ${expandedIndex === index ? 'active' : ''}`}
            style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}
            onClick={() => handleCardClick(index)}
          >
            <div className="project-thumbnail">
              <img src={project.image.url} alt={project.title} className="project-image" />
              <div className="project-overlay">
                <h3 className="project-title-overlay">{project.title}</h3>
              </div>
            </div>
          </div>
        ))}
      </div>

      {expandedIndex !== null && (
        <div className="project-detail-backdrop" onClick={() => setExpandedIndex(null)}>
          <div className="project-detail-panel" onClick={(e) => e.stopPropagation()}>
            <button className="detail-close" onClick={() => setExpandedIndex(null)}>
              <FaTimes />
            </button>
            <div className="detail-hero">
              <img
                src={projects[expandedIndex].image.url}
                alt={projects[expandedIndex].title}
                className="detail-hero-image"
              />
              <div className="detail-hero-gradient" />
              <h2 className="detail-hero-title">{projects[expandedIndex].title}</h2>
            </div>
            <div className="detail-body">
              {projects[expandedIndex].tags && (
                <div className="detail-tags">
                  {projects[expandedIndex].tags!.map((tag, i) => (
                    <span key={i} className="detail-tag">{tag}</span>
                  ))}
                </div>
              )}
              <p className="detail-description">{projects[expandedIndex].description}</p>
              <div className="detail-tech">
                {projects[expandedIndex].techUsed.split(', ').map((tech, i) => (
                  <span key={i} className="tech-badge">{tech}</span>
                ))}
              </div>
              {projects[expandedIndex].link && (
                <a
                  href={projects[expandedIndex].link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="detail-link"
                >
                  <FaExternalLinkAlt /> View Project
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;
